export class UrlModal {
  // static _URL = 'http://206.189.132.38:3005';
  // static _URL = 'https://api.doqmatokens.com';
  static _URL = 'https://dev.api.doqmatokens.com';
  // static _URL = 'http://localhost:3005';
  // static _URL = 'http://192.168.31.70:3005';
}